import { filters } from './modules/filters';
import { tiers } from './modules/tiers';
import { urls } from './modules/urls';
import { branding } from './modules/branding';
import { badges } from './modules/badges';
import { categories } from './modules/categories';
import { collections } from './modules/collections';

export const settings = {
  namespaced: true,
  state: {
    dirty: [],
  },
  mutations: {
    addDirtyTab(state, tab) {
      if (!state.dirty.includes(tab)) {
        state.dirty.push(tab);
      }
    },

    clearDirtyTabs(state) {
      state.dirty = [];
    },
  },
  actions: {
    saveChanges({ dispatch, state, commit }) {
      state.dirty.forEach(async tab => {
        switch (tab) {
          case 'tiers':
            dispatch('tiers/saveTiers');
            break;
          case 'filters':
            dispatch('filters/saveFilters');
            break;
          case 'defaults':
            dispatch('filters/saveDefaults');
            break;
          case 'settings':
            dispatch('urls/saveUrls');
            break;
          case 'branding':
            dispatch('branding/saveBranding');
            break;
          case 'badges':
            dispatch('badges/saveBadges');
            break;
          case 'categories':
            dispatch('categories/saveCategories');
            break;
          case 'collections':
            dispatch('collections/saveCollections');
            break;
        }
        commit('clearDirtyTabs');
      });
    },
  },
  modules: {
    tiers,
    filters,
    urls,
    branding,
    badges,
    categories,
    collections,
  },
};
